<div #dialog></div>

<button mat-flat-button (click)="showExistingIncidentSearchDialog()"><mat-icon>arrow_downward</mat-icon> IMPORT EXISTING INCIDENT</button>
<button mat-flat-button (click)="showNewIncidentDialog()"><mat-icon>add</mat-icon>CREATE INCIDENT</button>
<button mat-button (click)="RunCheckBeforeSaveReport()" [disabled]="!validateReport()"><mat-icon>save</mat-icon>SAVE</button>
<button mat-button (click)="cancelEdit()" *ngIf="isEdit===true"><mat-icon>delete_sweep</mat-icon>CANCEL EDIT</button>

<div style="border: 2px dashed grey; padding: 10px; margin: 10px;">
  <app-report-preview (TriggerAssociatedIncidents)="HandleAssociatedIncidentsTrigger($event)" [ReportInfo]="ReportInfo" [incidents]="Incidents" (removeIncident)="RemoveSelectedForReport($event)" [showDelete]="true" [isEditable]="true"></app-report-preview>
</div>

<hr />
<button mat-button (click)="RunCheckBeforeSaveReport()" [disabled]="!validateReport()"><mat-icon>save</mat-icon>SAVE</button>
